﻿import React from 'react';

import { getEpiData } from '../../../Utils/epiHelpers';


//animation components
import WaterDamageAnimation from './Animations/WaterDamageAnimation';
import DamageArrangementsAnimation from './Animations/DamageArrangementsAnimation';
import SnowDamageAnimation from './Animations/SnowDamageAnimation';
import VerminDamageAnimation from './Animations/VerminDamageAnimation';
import HeroSection from './Animations/HeroSection';
import FooterSection from './Animations/FooterSection';
import CheckmarkContainer from './Animations/CheckmarkContainer';
import EnvLogoAnimation from './Animations/EnvLogoAnimation';


//text components
import GenericText from './Texts/GenericText';
import EnvLogoText from './Texts/EnvLogoText';


const CottageCampaignPage = (props) => {
    const heading1 = getEpiData('heading-1', props.mountRootId) || '';
    const subtext1 = getEpiData('subtext-1', props.mountRootId) || '';
    const heading2 = getEpiData('heading-2', props.mountRootId) || '';
    const subtext2 = getEpiData('subtext-2', props.mountRootId) || '';
    const heading3 = getEpiData('heading-3', props.mountRootId) || '';
    const subtext3 = getEpiData('subtext-3', props.mountRootId) || '';
    const heading4 = getEpiData('heading-4', props.mountRootId) || '';
    const subtext4 = getEpiData('subtext-4', props.mountRootId) || '';
    const heading5 = getEpiData('heading-5', props.mountRootId) || '';
    const subtext5 = getEpiData('subtext-5', props.mountRootId) || '';
    const heading6 = getEpiData('heading-6', props.mountRootId) || '';
    const subtext6 = getEpiData('subtext-6', props.mountRootId) || '';
    const uspheading1 = getEpiData('usp-heading-1', props.mountRootId) || '';
    const uspsubtext1 = getEpiData('usp-subtext-1', props.mountRootId) || '';
    const uspheading2 = getEpiData('usp-heading-2', props.mountRootId) || '';
    const uspsubtext2 = getEpiData('usp-subtext-2', props.mountRootId) || '';
    const uspheading3 = getEpiData('usp-heading-3', props.mountRootId) || '';
    const uspsubtext3 = getEpiData('usp-subtext-3', props.mountRootId) || '';
    const buttonText1 = getEpiData('buttontext-1', props.mountRootId) || '';
    const buttonLink1 = getEpiData('buttonlink-1', props.mountRootId) || '';
    const buttonText2 = getEpiData('buttontext-2', props.mountRootId) || '';
    const buttonLink2 = getEpiData('buttonlink-2', props.mountRootId) || '';
    const finePrint = getEpiData('smallprint', props.mountRootId) || '';
    const envText = getEpiData('environment', props.mountRootId) || '';

    const headings = [uspheading1, uspheading2, uspheading3];
    const texts = [uspsubtext1, uspsubtext2, uspsubtext3];

    return (
        <div className="cottage-campaign">

            <HeroSection
                heading={heading1}
                text={subtext1}
                buttonLink={buttonLink1}
                buttonText={buttonText1}
            />

            <section className="cottage-campaign__usp">
                <CheckmarkContainer headings={headings} texts={texts} />
            </section>

            <section className="cottage-campaign__section cottage-campaign__water-damage">
                <WaterDamageAnimation />
                <GenericText heading={heading2} text={subtext2} />
            </section>

            <section className="cottage-campaign__section cottage-campaign__damage-arrangements">
                <GenericText heading={heading3} text={subtext3} />
                <DamageArrangementsAnimation />
            </section>

            <section className="cottage-campaign__section cottage-campaign__vermin-damage">
                <VerminDamageAnimation />
                <GenericText heading={heading4} text={subtext4} />
            </section>

            <section className="cottage-campaign__section cottage-campaign__snow-damage">
                <GenericText heading={heading5} text={subtext5} />
                <SnowDamageAnimation />
            </section>

            <section className="cottage-campaign__env-logo">
                <EnvLogoAnimation />
                <EnvLogoText text={envText} />
            </section>

            <FooterSection
                heading={heading6}
                text={subtext6}
                buttonLink={buttonLink2}
                buttonText={buttonText2}
                finePrint={finePrint}
            />
        </div>
        )
}
              
export default CottageCampaignPage;


